//@flow
import React from 'react';
import { themr } from 'react-css-themr';
import Icon from 'common/components/core/icon';

import theme from './ClearButton.scss';

type Props = {
    theme: Object
};

const ClearButton = React.memo(({ theme, ...rest }: Props) => (
    <div {...rest} className={theme.clearIndicatorContainer}>
        <Icon
            icon="cancel-thin"
            theme={theme}
            className={theme.selectClearIcon}
        />
    </div>
));

export default themr('ClearButton', theme)(ClearButton);
